import CssBaseline from "@material-ui/core/CssBaseline";
import { createTheme, MuiThemeProvider, Theme } from "@material-ui/core/styles";
import { ThemeOptions } from "@material-ui/core/styles/createTheme";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Route, Switch } from "react-router-dom";
import { IUser, ResponseSource } from "src/services";
import Component from "./components/Component";
import { AppContext } from "./components/withAppContext";
import withAxios, { IAxiosProps } from "./components/withAxios";
import { NavigationTracker } from "./components/NavigationTracker";
import AdminPage from "./pages/AdminPage";
import DirectorPage from "./pages/DirectorPage";
import HomePage from "./pages/home/Home";
import RespondentPage from "./pages/RespondentPage";
import SelectSchoolPage from "./pages/SelectSchoolPage";
import defaultTheme from "./theme";
import SignUppage from "./pages/home/signUp-pages/signup";
import LogInpage from "./pages/home/signIn-page/logIn";
import ForgotPassword from "./pages/home/signIn-page/forgotPass";
import ResetPassword from "./pages/home/signIn-page/changePassword";
import Nextpage from "./pages/home/name/name";
import SignUpPasspage from "./pages/home/signUp/signup";
import Schoolpage from "./pages/home/school/school";
import Leadpage from "./pages/home/Lead/lead";
import Pricepage from "./pages/director/price/price";
import Starterpage from "./pages/director/price/starter";
// import ProPage from "./pages/director/price/pro";
// import Premierpage from "./pages/director/price/premier";
import Purchase from "./pages/director/payment/purchase";
import PaybyCheque from "./pages/director/payment/PaybyCheque";
import Payment from "./pages/director/payment/paymentSucessfull";
import PaybyStripe from "./pages/director/payment/PaybyStripe";
import StripePaymentSucess from "./pages/director/payment/stripePaymentSucess";
import SignInpage from "./pages/home/signIn-page/signIn";
import PendingInvitePage from "./pages/home/signIn-page/PendingInvitePage";
import InvitationPasswordPage from "./pages/home/signIn-page/InvitationPasswordPage";
import RouteChangeHandler from "./pages/director/LogoutFromSite";
import EmbedPage from "./pages/home/embed";

interface IAppState {
  loadingUserInitial: boolean;
  user: IUser;
  theme: Theme;
  isNewUser: boolean,
  newUserDetails: any
}

type IProps = IAxiosProps & RouteComponentProps;

export default withRouter(
  withAxios(
    class App extends Component<IProps, IAppState> {
      public readonly state = this.buildState({
        loadingUserInitial: true,
        theme: createTheme(defaultTheme),
        user: {},
        isNewUser: false,
        newUserDetails: {}
      });

      public async componentDidMount() {
        // localStorage.removeItem("newUserDetails")
        this.loadUser();
        // const storedObject = JSON?.parse(localStorage?.getItem("newUserDetails"))||"";


      }


      public RemoveNewUserDetails(){
        sessionStorage.removeItem("newUserDetails")
        this.setState({ newUserDetails: {} })
      }


      public getNewLoginUserDetails(){
        const storedObject: string = sessionStorage.getItem("newUserDetails") || '{}';  // Fallback to an empty object string
        const parsedObject = JSON.parse(storedObject);
        if (Object.keys(parsedObject).length > 0) {
          this.setState({ newUserDetails: parsedObject })
        }
        return parsedObject
      }
      public onChangeUserDetails(value: any) {
        this.setState({ newUserDetails: value })
        sessionStorage.setItem("newUserDetails", JSON.stringify(value));
      }
      public render() {
        const { match } = this.props;
        const { user, theme, loadingUserInitial, isNewUser, newUserDetails } = this.state;
        return (
          <MuiThemeProvider theme={theme}>
            <AppContext.Provider
              value={{
                baseUri: match.url.replace(/\/$/, ""),
                loadingUserInitial,
                setTheme: this.setTheme,
                user,
                userChanged: this.handleUserChanged,
                userLogout: this.userLogout,
                changeIsNewUser: (value: any) => {
                  this.setState({ isNewUser: value })
                },
                isNewUser,
                onChangeUserDetails: (value: any) => this.onChangeUserDetails(value),
                newUserDetails,
                getNewLoginUserDetails:()=>{
                  this.getNewLoginUserDetails()
                },
                removeNewUserDetails:()=>{
                  this.RemoveNewUserDetails()
                }
              }}
            >
              <CssBaseline />
              <NavigationTracker />
              <RouteChangeHandler/>
              <Switch>
                <Route exact={true} path="/" component={HomePage} />
                <Route path="/login" component={HomePage} />
                <Route path="/password" component={LogInpage} />
                <Route path="/email/password" component={SignUpPasspage} />
                <Route path="/forgot/password" component={ForgotPassword} />
                <Route path="/reset/password/new" component={ResetPassword} />
                <Route path="/logout" component={HomePage} />
                <Route path='/sign-up' component={SignUppage} />
                <Route path='/pending-invite' component={PendingInvitePage} />
                <Route path='/invitation-password' component={InvitationPasswordPage} />
                <Route path='/sign-in' component={SignInpage} />
                <Route path='/name' component={Nextpage} />
                <Route path='/school' component={Schoolpage} />
                <Route path='/lead' component={Leadpage} />
                <Route exact={true} path="/embed" component={EmbedPage} />
                <Route exact={true} path="/embed/:schoolSlug" component={EmbedPage} />
                <Route exact={true} path="/embed/:schoolSlug/:level" component={EmbedPage} />
                <Route path='/price' component={Pricepage} />
                <Route path='/starterpage' component={Starterpage} />
                {/* <Route path='/propage' component={ProPage} />
                <Route path='/premierpage' component={Premierpage} /> */}
                <Route path='/purchase' component={Purchase} />
                <Route path='/plan-payment' component={PaybyCheque} />
                <Route path='/stripe-payment' component={PaybyStripe} />
                <Route path='/stripe-payment-success' component={StripePaymentSucess} />
                <Route path='/payment' component={Payment} />
                <Route
                  path="/student"
                  component={this.ParamsExtractingStudentRespondentPage}
                />
                <Route
                  path="/coach"
                  component={this.ParamsExtractingCoachRespondentPage}
                />
                <Route
                  path="/parent"
                  component={this.ParamsExtractingParentRespondentPage}
                />
                {user.isAdmin && <Route path="/admin" component={AdminPage} />}
                {user.isDirector && (
                  <Route path="/select-school" component={SelectSchoolPage} />
                )}
                {user.isDirector && (
                  <Route
                    path="/:schoolSlug"
                    component={this.ParamsDirectorPage}
                  />
                )}
                {/* Send to homepage if trying to go to page but not logged in */}
                <Route path="/:schoolSlug" component={HomePage} />
              </Switch>
            </AppContext.Provider>
          </MuiThemeProvider>
        );
      }

      private readonly ParamsDirectorPage = ({
        location,
        match,
        history,
      }: RouteComponentProps<{ schoolSlug: string }, {}>) => (
        <DirectorPage
          history={history}
          location={location}
          match={match}
          schoolSlug={match.params.schoolSlug}
          user={this.state.user}
          setTheme={this.setTheme}
        />
      );

      private readonly ParamsExtractingStudentRespondentPage = (
        routeCompProps: RouteComponentProps<{}>
      ) => {
        return this.ParamsExtractingRespondentPage(
          routeCompProps,
          ResponseSource.student
        );
      };

      private readonly ParamsExtractingCoachRespondentPage = (
        routeCompProps: RouteComponentProps<{}>
      ) => {
        return this.ParamsExtractingRespondentPage(
          routeCompProps,
          ResponseSource.coach
        );
      };

      private readonly ParamsExtractingParentRespondentPage = (
        routeCompProps: RouteComponentProps<{}>
      ) => {
        return this.ParamsExtractingRespondentPage(
          routeCompProps,
          ResponseSource.parent
        );
      };

      private readonly ParamsExtractingRespondentPage = (
        { history }: RouteComponentProps<{}>,
        responseSource: number
      ) => (
        <RespondentPage
          responseSource={responseSource}
          history={history}
          setTheme={this.setTheme}
        />
      );

      private setTheme = (theme: ThemeOptions) => {
        this.setState({
          theme: createTheme({
            ...defaultTheme,
            ...theme,
          }),
        });
      };

      private handleUserChanged = (user: IUser) => {
        this.setState({
          user,
        });
        (window as any).updateDocsBotUser?.(user);
      };

      private userLogout = () =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {
            user: {},
          },
          async () => {
            sessionStorage.removeItem("newUserDetails")
            if (this.state.user.id !== undefined) {
              await this.buildPost<{}, void>(this, "logout")({});
            }
            (window as any).clearDocsBotUser?.();
          },
          () => {
            window.alert("Failed to logout");
          }
        );

      private loadUser = () =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {
            loadingUserInitial: false,
          },
          async () => {
            const res: any = await this.buildGet<IUser>(this, "user")()
            console.log("res=========USER", res)
            this.setState({ user: res, isNewUser: true });
            (window as any).updateDocsBotUser?.(res);
          },
          () => {
            this.setState({ loadingUserInitial: false });
            (window as any).initDocsBotAnonymous?.();
          }
        );
    }
  )
);




// WEBPACK FOOTER //
// ./src/App.tsx